(function () {
  "use strict";

  angular.module("sempraWebapp").component("alertHistory", {
    templateUrl: "app/facilityKarcherDetails/alertHistory/alertHistory.html",
    controller: alertHistory,
    bindings: {
      facilityId: "<",
      facilityName: "<",
      facilityType: "<",
      deviceId: "<"
    },
    controllerAs: "vm"
  });

  function alertHistory(
    dashboardKarcherActions,
    $translate,
    layoutActions,
    reportExportUtil,
    exportToCsv,
    localeFilters,
    helperService
  ) {
    var vm = this;
    // Grid data
    setGridData();

    vm.$onInit = function () {
      if (vm.facilityId) {
        refreshHistoryAlarmList();
      }
    };

    vm.$onChanges = function () {
      if (vm.facilityId) {
        refreshHistoryAlarmList();
      }
    };

    vm.pageChanged = function (page, limit) {
      vm.alarmsPage = page;
      vm.alarmsPageSize = limit;
      refreshHistoryAlarmList();
    };

    vm.sortChanged = function (order) {
      var orderQuery = getOrderObject(order);
      vm.alarmsOrderBy = orderQuery.orderBy;
      vm.alarmsOrder = orderQuery.order;
      refreshHistoryAlarmList();
    };

    vm.refreshAlertPage = function () {
      setGridData();
      refreshHistoryAlarmList();
    };

    vm.downloadCsv = function () {
      getDataForCSVDownload(vm.alarmsTotal).then(function (csvData) {
        var isStandardAlarm = vm.facilityType !== 'KARCHER' && vm.facilityType !== 'ROLLOVER';
        
        var updatedData = {
          groupNames: isStandardAlarm ? [
            $translate.instant("ALERT_CODE"),
            $translate.instant("ALERT_NAME"),
            $translate.instant("ALERT_DESCRIPTION"),
            $translate.instant("LEVEL"),
            $translate.instant("STATUS")
          ] : [
            $translate.instant("ALERT_CODE"),
            $translate.instant("COMPANY_NAME"),
            $translate.instant("SITE_NAME"),
            $translate.instant("FACILITY_NAME"),
            $translate.instant("ALERT_NAME"),
            $translate.instant("ALERT_DESCRIPTION"),
            $translate.instant("STATUS")
          ],
          groupTotal: [],
          groupsData: csvData.content.map(function (item) {
            return {
              groupValue: localeFilters.hourly(item.timestamp),
              values: isStandardAlarm ? [
                item.sourceId,
                item.content,
                item.details,
                item.level,
                item.resolved
                  ? $translate.instant("RESOLVED_STATUS")
                  : $translate.instant("NOT_RESOLVED_STATUS")
              ] : [
                item.karcherFault.number,
                item.companyName,
                item.siteName,
                item.washFacilityName,
                item.karcherFault.name,
                item.karcherFault.description,
                item.status
                  ? $translate.instant("RESOLVED_STATUS")
                  : $translate.instant("NOT_RESOLVED_STATUS")
              ]
            };
          })
        };
        var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
          $translate.instant("DATE"),
          updatedData,
          reportExportUtil.ValueFormattersEnum.DEFAULT,
          reportExportUtil.ValueFormattersEnum.DEFAULT
        );

        exportToCsv.export(
          jsonArrayForExport,
          vm.facilityName + $translate.instant("ALARM_HISTORY"),
          true
        );
      });
    };

    function setGridData() {
      vm.alarmsOrderBy = "timestamp";
      vm.alarmsOrder = "desc";
      vm.alarmsPage = 1;
      vm.alarmsTotal = 0;
      vm.alarmsPageSize = 10;
      vm.alarmsPageOptions = [5, 10, 15, 50, 100];
      vm.pagerTranslations = {
        page: $translate.instant("GRID_PAGER_PAGE"),
        rowsPerPage: $translate.instant("GRID_PAGER_ROWS_PER_PAGE"),
        of: $translate.instant("GRID_PAGER_PAGE_OF")
      };
    }

    function refreshHistoryAlarmList() {
      layoutActions.showLoader();
      var isStandardHistory = shouldUseStandardHistory();
      var apiCall;
      if (shouldUseKarcherHistory()) {
        apiCall = dashboardKarcherActions.getKarcherAlarmsHistoryList(
          "",
          vm.facilityId,
          "",
          "",
          vm.alarmsPage - 1,
          vm.alarmsPageSize,
          helperService.orderByRemover(vm.alarmsOrderBy),
          vm.alarmsOrder
        );
      } else if (shouldUseDeviceHistory()) {
        apiCall = dashboardKarcherActions.getAlarmHistoryListByDevice(
          vm.deviceId,
          vm.alarmsPage - 1,
          vm.alarmsPageSize,
          helperService.orderByRemover(vm.alarmsOrderBy),
          vm.alarmsOrder
        );
      } else {
        apiCall = dashboardKarcherActions.getAlarmHistoryList(
          vm.facilityId,
          vm.alarmsPage - 1,
          vm.alarmsPageSize,
          helperService.orderByRemover(vm.alarmsOrderBy),
          vm.alarmsOrder
        );
      }
      
      apiCall
        .then(function (data) {
          var content = data.content || [];
          if (isStandardHistory) {
            normalizeAlarmEntries(content);
          }
          if (content.length === 0) {
            vm.alarmList = [];
            vm.alarmList.push({
              timestamp: $translate.instant("NOTHING_TO_DISPLAY"),
              displayNotResolve: true
            });
          } else {
            vm.alarmList = setStateIcon(content, isStandardHistory);
          }
          vm.alarmsTotal = data.totalElements;
          layoutActions.hideLoader();
        });
    }

    function getDataForCSVDownload(totalNumberOfElements) {
      layoutActions.showLoader();
      
      var isStandardHistory = shouldUseStandardHistory();
      var apiCall;
      if (shouldUseKarcherHistory()) {
        apiCall = dashboardKarcherActions.getKarcherAlarmsHistoryList(
          "",
          vm.facilityId,
          "",
          "",
          vm.alarmsPage - 1,
          totalNumberOfElements,
          vm.alarmsOrderBy,
          vm.alarmsOrder
        );
      } else if (shouldUseDeviceHistory()) {
        apiCall = dashboardKarcherActions.getAlarmHistoryListByDevice(
          vm.deviceId,
          vm.alarmsPage - 1,
          totalNumberOfElements,
          vm.alarmsOrderBy,
          vm.alarmsOrder
        );
      } else {
        apiCall = dashboardKarcherActions.getAlarmHistoryList(
          vm.facilityId,
          vm.alarmsPage - 1,
          totalNumberOfElements,
          vm.alarmsOrderBy,
          vm.alarmsOrder
        );
      }
      
      return apiCall
        .then(function (data) {
          layoutActions.hideLoader();
          if (isStandardHistory) {
            normalizeAlarmEntries(data.content || []);
          }
          return data;
        });
    }

    function shouldUseKarcherHistory() {
      return vm.facilityType === 'KARCHER' || vm.facilityType === 'ROLLOVER';
    }

    function shouldUseDeviceHistory() {
      return vm.facilityType === 'CHANGER' && !!vm.deviceId;
    }

    function shouldUseStandardHistory() {
      return !shouldUseKarcherHistory();
    }

    function normalizeAlarmEntries(entries) {
      if (!entries || !entries.length) {
        return;
      }
      entries.forEach(function (alarm) {
        enrichStandardAlarm(alarm);
      });
    }

    function enrichStandardAlarm(alarm) {
      var normalizedStatus = mapAlarmLevelToStatus(alarm.level);
      if (!alarm.karcherFault) {
        alarm.karcherFault = {};
      }
      if (alarm.karcherFault) {
        alarm.karcherFault.number = alarm.karcherFault.number || alarm.sourceId;
        alarm.karcherFault.name = alarm.karcherFault.name || alarm.content;
        alarm.karcherFault.description = alarm.karcherFault.description || alarm.details;
        alarm.karcherFault.washFacilityStatus = alarm.karcherFault.washFacilityStatus || normalizedStatus;
      }
      if (typeof alarm.status !== "boolean") {
        alarm.status = typeof alarm.resolved === "boolean" ? alarm.resolved : false;
      }
      if (!alarm.washFacilityName && vm.facilityName) {
        alarm.washFacilityName = vm.facilityName;
      }
    }

    function mapAlarmLevelToStatus(level) {
      switch ((level || '').toUpperCase()) {
        case 'ERROR':
        case 'ALARM':
          return 'ALARM';
        case 'WARNING':
          return 'WARNING';
        case 'INFO':
        default:
          return 'INFO';
      }
    }

    function getOrderObject(order) {
      var result = {
        order: "asc",
        orderBy: order
      };

      if (order.indexOf("-") > -1) {
        result.order = "desc";
        result.orderBy = order.substring(1);
      }
      return result;
    }

    function setStateIcon(data, isStandardAlarm) {
      for (var i = 0; i < data.length; i++) {
        var caseItem;
        if (isStandardAlarm) {
          caseItem = data[i].karcherFault
            ? data[i].karcherFault.washFacilityStatus
            : mapAlarmLevelToStatus(data[i].level);
        } else {
          caseItem = data[i].karcherFault.washFacilityStatus;
        }
        
        switch (caseItem) {
          case "INFO":
            data[i].icon = "assets/icons/ic_low_alarm.svg";
            break;
          case "WARNING":
            data[i].icon = "assets/icons/ic_medium_alarm.svg";
            break;
          case "ALARM":
          case "ERROR":
            data[i].icon = "assets/icons/ic_high_alarm.svg";
            break;
          default:
            data[i].icon = "assets/icons/ic_low_alarm.svg";
            break;
        }
      }
      return data;
    }
  }
})();
